// extracted by mini-css-extract-plugin
module.exports = {"box":"NavigationBox-module--box--3ZuGB","link":"NavigationBox-module--link--3oilt","active":"NavigationBox-module--active--UPTM4"};